import React, { useState } from "react";
import "../App.css";
import { API_URL } from '../config.js'; // Importiere die API URL

const Appointment = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    privacy: false,
  });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setForm(f => ({
      ...f,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    if (!form.name || !form.email || !form.phone || !form.message) {
      setError("Bitte alle Felder ausfüllen.");
      return;
    }
    if (!form.privacy) {
      setError("Bitte akzeptieren Sie die Datenschutzerklärung.");
      return;
    }
    setError("");
    

    fetch(`${API_URL}/api/termin`, {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({
    name: form.name,
    email: form.email,
    phone: form.phone,
    message: form.message,
  }),
})
  .then(res => res.json())
  .then(data => {
    if (data.success) {
      setSubmitted(true);
    } else {
      setError("Fehler beim Senden. Bitte versuchen Sie es später erneut.");
    }
  })
  .catch(() => setError("Fehler beim Senden. Bitte versuchen Sie es später erneut."));
  };

  if (submitted) {
    return (
      <section className="appointment-section">
        <h2>Termin Anfrage gesendet!</h2>
        <p>Vielen Dank für Ihre Anfrage. Wir melden uns so bald wie möglich bei Ihnen.</p>
      </section>
    );
  }

  return (
    <>
      <section className="page-header">
        <h1>Kontakt & Termin</h1>
        <p>Wir freuen uns auf Ihre Anfrage</p>
      </section>
      <section className="appointment-section">
      <form className="appointment-form" onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          placeholder="Ihr Name"
          value={form.name}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Ihre E-Mail"
          value={form.email}
          onChange={handleChange}
          required
        />
        <input
          type="tel"
          name="phone"
          placeholder="Ihre Telefonnummer"
          value={form.phone}
          onChange={handleChange}
          required
        />
        <textarea
          name="message"
          placeholder="Ihre Nachricht"
          value={form.message}
          onChange={handleChange}
          rows={5}
          required
        />
        <label className="privacy-label">
          <input
            type="checkbox"
            name="privacy"
            checked={form.privacy}
            onChange={handleChange}
            required
          />
          Ich akzeptiere die <a href="/datenschutz" target="_blank" rel="noopener noreferrer">Datenschutzerklärung</a>.
        </label>
        {error && <div className="form-error">{error}</div>}
        <button type="submit" className="appointment-btn">Anfrage senden</button>
      </form>
    </section>
    </>
  );
};

export default Appointment;